"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SelectNative from "./SelectNative.js";
import SelectRoot from "./SelectRoot.js";
import SelectTrigger from "./SelectTrigger.js";
import SelectOption from "./SelectOption.js";
import SelectOptionGroup from "./SelectOptionGroup.js";
import SelectCustom from "./SelectCustom.js";
const Select = (props) => {
    const { children } = props;
    return (_jsx(SelectRoot, { ...props, children: (props) => {
            const { options } = props;
            const hasOptionChildren = React.Children.toArray(children).some((child) => {
                return React.isValidElement(child) && child.type === "option";
            });
            const hasOptions = Boolean(options || hasOptionChildren);
            if (!hasOptions) {
                return _jsx(SelectTrigger, { ...props, children: children });
            }
            return (_jsxs(SelectNative, { ...props, children: [options?.map((option) => (_jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value))), children] }));
        } }));
};
Select.displayName = "Select";
Select.Custom = SelectCustom;
Select.Option = SelectOption;
Select.OptionGroup = SelectOptionGroup;
export default Select;
